import React from "react";

export enum DropdownMenuVariant {
  PRIMARY = "primary",
  DESTRUCTIVE = "destructive",
}

export interface Action<DataT> {
  id: string;
  label?: string;
  icon?: React.ElementType | React.ReactNode;
  onClick?: (item?: DataT) => void;
  variant?: DropdownMenuVariant;
  group?: string;
  className?: string;
  getDisabled?: (item?: DataT) => boolean;
  showIf?: (item?: DataT) => boolean;
  isDivider?: boolean;
  shouldShow?: boolean;
  tooltipClassName?: string;
  tooltipContent?: string | ((item?: DataT) => string | undefined);
  infoTooltipContent?: string | ((item?: DataT) => string | undefined);
  subItems?: Action<DataT>[];
}

export interface DropdownMenuProps<DataT> {
  menuItems: Action<DataT>[];
  isOnHover?: boolean;
  icon?: React.ReactNode;
  label?: string;
  item?: DataT;
  triggerClassName?: string;
  onTriggerClick?: (item?: DataT) => void;
  contentClassName?: string;
}
